import PropTypes from 'prop-types';
import React from 'react';

import CapitalizeFirstWord from 'components/text_editor/plugins/capitalize_first_word';
import CapitalizeI from 'components/text_editor/plugins/capitalize_i';
import Placeholders, { useFocusFirstPlaceholder } from 'components/text_editor/plugins/placeholders';
import SubmitOnEnter from 'components/text_editor/plugins/submit_on_enter';
import TextEditor, { getEditorProps, useEditorRef, usePlugins } from 'components/text_editor';
import { usePhraseSuggestionsPlugin } from 'components/text_editor/plugins/phrase_suggestions';
import { useToggleAnswerPanel } from '../plugins/toggle_answer_panel';

export default function MessagingEditor(props) {
  const { onChange } = props;
  const editorRef = useEditorRef(props.editorRef);
  useFocusFirstPlaceholder(props.editorRef.current, onChange);

  const toggleAnswerPanel = useToggleAnswerPanel();
  const phraseSuggestionsPlugin = usePhraseSuggestionsPlugin(true);

  const plugins = usePlugins(
    () => [
      CapitalizeI(),
      CapitalizeFirstWord(),
      // Put phrase suggestions before SubmitOnEnter to ensure we don't submit while a phrase suggestion
      // is shown.
      phraseSuggestionsPlugin,
      SubmitOnEnter(props.onSubmit),
      Placeholders(),
      toggleAnswerPanel,
      ...props.plugins,
    ],
    [phraseSuggestionsPlugin, props.onSubmit]
  );

  const editorProps = getEditorProps(props);
  return <TextEditor {...editorProps} editorRef={editorRef} plugins={plugins} />;
}

MessagingEditor.defaultProps = {
  plugins: [],
};

MessagingEditor.propTypes = {
  editorRef: PropTypes.shape({ current: PropTypes.any }),
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  plugins: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/editors/messaging.jsx